import styled from 'styled-components'
import { colors } from 'src/Global/Styles/variables'

export const InitialButton = styled.button<{
  filled?: boolean
  disabled?: boolean
}>`
  font-family: Lato;
  padding: 1rem;
  width: 100%;
  border-radius: 5px;
  ${(props) =>
    props.filled
      ? `
    background-color: ${
      props.disabled ? '#6C757D' : props.theme.mainThemeColor
    };
    color: ${colors.white};
    `
      : `
    background-color: ${colors.white};
    color: ${props.theme.mainThemeColor};
    border: 1px solid ${props.theme.mainThemeColor};
  `}
`

export const NextButton = styled(InitialButton)`
  max-width: 175px;

  @media (min-width: 375px) {
    max-width: 200px;
  }

  @media (min-width: 768px) {
    max-width: 300px;
  }
`

export const BackButton = styled(InitialButton)`
  max-width: 100px;

  @media (min-width: 375px) {
    max-width: 125px;
  }

  @media (min-width: 768px) {
    max-width: 150px;
  }
`

export const ResendButton = styled(InitialButton)`
  margin-top: 1rem;
`

export const TakePhotoButton = styled(InitialButton)``
